import React from 'react';
import CssBaseline from '@material-ui/core/CssBaseline';
import { Routes } from '../../config/Routes';
import AppbarMenu from './navbar';
import Sidebar from './sidebarList';
import SidebarContent from './sidebar';
import useStyles from './styles';

interface IProps {
  visible: boolean;
}

export default function Appbar({ visible }: IProps) {
  if (visible) {
    // return <ResponsiveDrawer />
    return <DataDrawer />;
  } else {
    return <Routes />;
  }
}

function DataDrawer() {
  // console.log('Render DataDrawer');
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <CssBaseline />
      <AppbarMenu />
      <Sidebar />
      <SidebarContent />
    </div>
  );
}
